<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M2 12V4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12Z"
    fill="#FF9F04"
  />
  <path
    d="M8.64077 6.79297C8.88306 6.55064 9.27624 6.55086 9.5187 6.79297L12.8185 10.0928C12.9957 10.2702 13.0491 10.5368 12.9533 10.7686C12.8572 11.0005 12.6301 11.1523 12.3791 11.1523H3.62124C3.37014 11.1523 3.1431 11.0005 3.04702 10.7686C2.9512 10.5368 3.00462 10.2702 3.18179 10.0928L4.84194 8.43164C4.95834 8.31521 5.11676 8.25 5.2814 8.25C5.44585 8.25003 5.60354 8.31544 5.71987 8.43164L6.36148 9.07324L8.64077 6.79297ZM5.26187 5C5.77212 5 6.18559 5.41359 6.18569 5.92383C6.18569 6.43415 5.77219 6.84766 5.26187 6.84766C4.75163 6.84755 4.33804 6.43409 4.33804 5.92383C4.33814 5.41366 4.7517 5.0001 5.26187 5Z"
    fill="white"
  />
</template>
